// src/api/api.js
import store from '../store';               // <-- default import (no braces)
import { selectTestbed } from '../slices/testbedSlice';
import { API_BASE, API_PREFIX } from '../config/env';

// Normalize once
const BASE = API_BASE.replace(/\/$/, '');
const PREFIX = API_PREFIX.startsWith('/') ? API_PREFIX : `/${API_PREFIX}`;

/**
 * Build a URL like:
 *   http://host:8081/api/testbeds/<tbId>/<path...>
 * path should start with "/" (we guard anyway).
 */
export function tbUrl(path = '/') {
  const state = store.getState();
  const tbId = selectTestbed(state);
  const safePath = path.startsWith('/') ? path : `/${path}`;

  if (!tbId) {
    // no selection yet → caller can handle redirect/404
    return `${BASE}${PREFIX}${safePath}`;
  }
  return `${BASE}${PREFIX}/testbeds/${tbId}${safePath}`;
}

/** Log which testbed + exact URLs are active (call e.g. on Home mount) */
export function logActiveTestbed(where = 'nav') {
  const state = store.getState();
  const tbId = selectTestbed(state) || '(none)';
  const agg = tbId !== '(none)'
    ? `${BASE}${PREFIX}/testbeds/${tbId}/aggregator/`
    : `${BASE}${PREFIX}/aggregator/`;
  const job = tbId !== '(none)'
    ? `${BASE}${PREFIX}/testbeds/${tbId}/jobmanager/groups`
    : `${BASE}${PREFIX}/jobmanager/groups`;

  console.info(
    `%c[TESTBED] ${where}`,
    'color:#6c5ce7;font-weight:bold',
    { tbId, aggregator: agg, jobManager: job }
  );
}
